//* --------------------------------------------------*\
//    $SELECTORS - CSS selectors ONLY
// -  tag names, #ids, .classnames, [attributes], etc
//* --------------------------------------------------*/

const SELECTORS = {
  ACCORDION_TOGGLE: '.footer__accordion-toggle',
  ALL: '#all',
  ANCHOR: 'a',
  ANCHOR_WITH_HREF: 'a[href]',
  ANIMATED_IMPACT_MODULE_IMAGE: 'animated-impact-module-image',
  ANIMATED_IMPACT_MODULE_NUMBER: 'animated-impact-module-number',
  API_RESULTS: '[data-loadcomponent="APIResults"]',
  AREAS_OF_FOCUS_ITEM: '.js-aof-item',
  AREAS_OF_FOCUS_ITEM_DRAWER: '.areas-of-focus__item-drawer',
  AREAS_OF_FOCUS_ITEM_TOGGLE: '.js-aof-toggle',
  AREAS_OF_IMPACT_CARD_ICON: 'areas-of-impact-tabs__item-card-icon',
  AREAS_OF_IMPACT_CARD_TOGGLE: 'areas-of-impact-tabs__item-card-toggle',
  AREAS_OF_IMPACT_CONTENT: 'areas-of-impact-tabs__content',
  AREAS_OF_IMPACT_ITEM: 'areas-of-impact-tabs__item',
  AREAS_OF_IMPACT_ITEM_CARD: 'areas-of-impact-tabs__item-card',
  AREAS_OF_IMPACT_LAYOUT: 'areas-of-impact-tabs__layout',
  AREAS_OF_IMPACT_VISUAL_SLIDE: 'areas-of-impact-tabs__visual-slide',
  ARIA_CONTROLS: 'aria-controls',
  ARIA_EXPANDED: 'aria-expanded',
  ARTICLE_CAROUSEL: '[data-article-carousel]',
  ARTICLE_CAROUSEL_SLIDE: '[data-carousel-slide]',
  ARTICLE_CAROUSEL_NAV: '[data-carousel-nav]',
  ARTICLE_CAROUSEL_PREV: '[data-carousel-prev]',
  ARTICLE_CAROUSEL_NEXT: '[data-carousel-next]',
  ARTICLE_CONTENT: '.article-content',
  ARTICLE_SIDEBAR: '.article-content__sidebar',
  ARTICLE_SIDEBAR_NAV: '.article-content__sidebar-nav',
  ARTICLE_SIDEBAR_TOGGLE: '.article-content__sidebar-toggle',
  ARTICLE_SIDEBAR_TOGGLE_LABEL: '.article-content__sidebar-toggle-label',
  ARTICLE_SIDEBAR_LIST: '.article-content__sidebar-list',
  ARTICLE_SIDEBAR_CONTENT: '.article-content__right-block',
  ARTICLE_SIDEBAR_HEADINGS: 'h2, h3',
  ARTICLE_SIDEBAR_ANCHOR: 'a[href^="#"]',
  BACKGROUND: '.background',
  BOARD_OF_TRUSTEES_BLOCK: '.board-of-trustees__section-block',
  BOARD_OF_TRUSTEES_BLOCK_MOBILE:
    '.board-of-trustees__section-block.mobile-block',
  BOARD_OF_TRUSTEES_BLOCK_DESKTOP:
    '.board-of-trustees__section-block.desktop-block',
  BOARD_OF_TRUSTEES_SECTION_SLIDE: '.board-of-trustees__section-slide',
  BOARD_OF_TRUSTEES_SWIPER: '.board-of-trustees__section-carousel',
  BOARD_OF_TRUSTEES_NEXT: '.board-of-trustees__section-carousel__btn.next',
  BOARD_OF_TRUSTEES_PREV: '.board-of-trustees__section-carousel__btn.prev',
  BOARD_OF_TRUSTEES_SECTION: '.board-of-trustees__section',
  BUTTON: 'button',
  CHECKED: ':checked',
  CHECKED_LABEL: ':checked + label',
  CHECKBOX: 'checkbox',
  CLOSE: '.close',
  CLOSE_SEARCH: '.close-search',
  DATA_BOTTOM: 'data-bottomposition',
  DATA_HALFWAY: 'data-halfway',
  DATA_HAS_ANIMATED: 'data-has-animated',
  DATA_LAZY_LOAD: 'data-lazyload',
  DATA_MOUSEFOLLOW: '[data-mousefollow]',
  DATA_POSITION: 'data-position',
  DATA_VISIBLE: '[data-visible]',
  DIV: 'div',
  BODY_VIDEO_COMPONENT: '.body-video__container',
  BODY_VIDEO_COOKIE_SETTINGS: '.js-bv-cookie-settings',
  BODY_VIDEO_CURSOR: '.js-bv-cursor',
  BODY_VIDEO_IFRAME: '.body-video__embed iframe',
  BODY_VIDEO_PLAY: '.js-bv-play',
  BODY_VIDEO_PREVIEW: '.js-bv-preview',
  BODY_VIDEO_THUMB: '.js-bv-thumb',
  BODY_VIDEO_VIDEO: '.js-bv-video',
  DESKTOP_HEADER_TOGGLE: '.desktop-header__toggle',
  DESKTOP_HEADER_ITEM: '.desktop-header__item',
  DESKTOP_HEADER_DROPDOWN: '.desktop-header__dropdown',
  DESKTOP_SEARCH_TOGGLE: '.desktop-header__search-toggle',
  DROPDOWN: '.dropdown',
  DROPDOWN_CONTENT: '.dropdown__content',
  DROPDOWN_TOGGLE: '.dropdown__toggle',
  DROPDOWN_TOGGLE_CLICK: '.dropdown.click',
  DROPDOWN_TOGGLE_HOVER: '.dropdown.hover',
  EMAIL: '.share--email',
  EYE: '.eye',
  FACEBOOK: '.share--fb',
  FEATURED_CONTENT_SWIPER: '.js-featured-swiper',
  FEATURED_CONTENT_WRAPPER: '.js-featured-swiper .swiper-wrapper',
  FEATURED_CONTENT_TAB: '.featured-content__tab',
  FEATURED_CONTENT_PREV: '.featured-content__nav-prev',
  FEATURED_CONTENT_NEXT: '.featured-content__nav-next',
  FILE_INPUT: 'input[type=file]',
  FILTER: '.filter',
  FILTER_CHOICE: '.filter-choice',
  FILTER_FORM: '.filters-form',
  FILTER_OPTION: '.filter-option',
  FILTER_TRIGGER: '.filter-trigger',
  FLOATING_NAV_DROPDOWN: '.floating-nav__dropdown',
  FLOATING_NAV_DROPDOWN_LINK: '.floating-nav__dropdown-link',
  FLOATING_NAV_LINK: '.floating-nav__link',
  FLOATING_NAV_MOBILE: '.floating-nav__mobile',
  FLOATING_NAV_STICKY: '.floating-nav-sticky',
  FLOATING_NAV_TOGGLE: '.floating-nav__toggle',
  FLOATING_NAV_TOGGLE_LABEL: '.floating-nav__toggle-label',
  FINANCIALS_REPEATER: '[data-fin-repeater]',
  FINANCIALS_BLOCK: '[data-fin-block]',
  FINANCIALS_SHOW_MORE: '[data-fin-show-more]',
  FORM: 'form',
  FORM_FIELDS: 'input, select, textarea',
  FULL_WIDTH_DROPDOWN_ITEM: '.full-width-dropdown__item',
  FULL_WIDTH_DROPDOWN_TOGGLE: '.full-width-dropdown__toggle',
  FULL_WIDTH_DROPDOWN_DRAWER: '.full-width-dropdown__drawer',
  FUN_FACT_ITEM: '.fun-fact__item',
  HASH: '#',
  HAS_VALUE_CLASS: 'has-value',
  HAS_ERROR_CLASS: 'has-error',
  HEADER_COMPONENT: '.header',
  HEADLINE_AND_FORM_EMAIL_FIELD: 'h-and-f--email',
  HEADLINE_AND_FORM_FORM: '.headline-and-form__form',
  HEADLINE_AND_FORM_INQUIRY_TYPE: '.headline-and-form__inquiry-type',
  HEADLINE_AND_FORM_LABEL: '.custom-select__label',
  HEADLINE_AND_FORM_NAME_FIELD: 'h-and-f--name',
  HEADLINE_AND_FORM_NATIVE_SELECT: 'select',
  HEADLINE_AND_FORM_OPTION: '.custom-select__option',
  HEADLINE_AND_FORM_OPTIONS: '.custom-select__options',
  HEADLINE_AND_FORM_ORGANIZATION_FIELD: 'h-and-f--organization',
  HEADLINE_AND_FORM_SUBMIT: 'button[type="submit"]',
  HEADLINE_AND_FORM_TRIGGER: '.custom-select__trigger',
  HERO_SLIDER_SWIPER: '[data-hero-slider-swiper]',
  HERO_SLIDER_WRAPPER: '.hero-slider__wrapper',
  HREF: 'href',
  HTML: 'html',
  ILLUSTRATION_HERO: '.illustration-hero',
  ILLUSTRATION_HERO__IMAGE: '.illustration-hero__image.has-lottie',
  ILLUSTRATION_HERO_LOTTIE: '.illustration-hero__lottie',
  ILLUSTRATION_HERO_LOTTIE_PLAYER: '.illustration-hero__lottie-player',
  ILLUSTRATION_HERO_LOTTIE_POSTER: '.illustration-hero__lottie-poster',
  IMAGE_CAPTION_CAROUSEL_SWIPER: '.image-caption-carousel__swiper',
  IMAGE_CAPTION_CAROUSEL_NEXT: '.image-caption-carousel__swiper__btn.next',
  IMAGE_CAPTION_CAROUSEL_PREV: '.image-caption-carousel__swiper__btn.prev',
  IMAGE_CAPTION_CAROUSEL_TEAM_MEMBER: '.image-caption-carousel__team-member',
  IMAGE_CAPTION_TRIGGER: '[data-image-caption-trigger]',
  IMAGE_CAPTION_CONTENT: '.image-caption__content',
  IMAGE_CAPTION_COMPONENT: '[data-image-caption]',
  IMPACT_MODULE_CAPTION: 'impact-module__caption',
  IMPACT_MODULE_CAPTION_TOGGLE: 'impact-module__caption-toggle',
  INVALID: ':invalid',
  IS_ACTIVE: 'is-active',
  IS_EXPANDED: 'is-expanded',
  LEADERSHIP_CAROUSEL_SWIPER: '.leadership-carousel__swiper',
  LEADERSHIP_CAROUSEL_SWIPER_SLIDE: '.leadership-carousel__swiper__slide',
  LEADERSHIP_CAROUSEL_NEXT: '.leadership-carousel__swiper__btn.next',
  LEADERSHIP_CAROUSEL_PREV: '.leadership-carousel__swiper__btn.prev',
  LEADERSHIP_CAROUSEL_TEAM_MEMBER: '.leadership-carousel__team-member',
  LINKEDIN: '.share--li',
  LIST_AND_IMAGE_CAPTION_TOGGLE: 'list-and-image__caption-toggle',
  LIST_AND_IMAGE_CAPTION: 'list-and-image__caption',
  LIST_ITEM: 'li',
  LOADING: '.loading',
  LOAD_MORE: '.load-more',
  MAILCHIMP_RESPONSE: '.mc4wp-response',
  MAX_DESKTOP: '(max-width: 1023px)',
  MAX_TABLET: '(max-width: 767px)',
  MEDIA_EMBED_NEXT: '.js-me-next',
  MEDIA_EMBED_PREV: '.js-me-prev',
  MEDIA_EMBED_VIDEO: '.media-embed__video',
  MEDIA_EMBED_VIEWPORT: '.js-me-viewport',
  MENU_TXT: '.menu-txt',
  MIN_TABLET: '(min-width: 768px)',
  MOBILE_HEADER: '.mobile-header',
  MOBILE_MENU: '.mobile-menu',
  MOBILE_MENU_OVERLAY: '.mobile-menu-overlay',
  MOBILE_MENU_SUB_TOGGLE: '.mobile-menu__toggle',
  MOBILE_MENU_TOGGLE: '.mobile-header__dropdown-toggle',
  MOBILE_SEARCH_TOGGLE: '.mobile-header__search-toggle',
  MOBILE_SEARCH: '.mobile-search',
  MOBILE_SEARCH_INPUT: '.mobile-search__input',
  MOBILE_SEARCH_BACK: '.mobile-search__back',
  MOBILE_SEARCH_SUGGESTIONS: '.mobile-search__suggestions',
  MOBILE_SEARCH_SUGGESTIONS_LIST: '.mobile-search__suggestions-list',
  MOBILE_SEARCH_RESULTS_LIST: '.mobile-search__results-list',
  MOUSEFOLLOW: '.mousefollow',
  NAV_TRIGGER: '.nav_trigger',
  NESTED: '.nested',
  NEXT_FACT: '.next-fact',
  OGDESC: 'meta[property="og:description"]',
  OGTITLE: 'meta[property="og:title"]',
  OGURL: 'meta[property="og:url"]',
  OPEN_SEARCH: '.open-search',
  OPTGROUP: 'optgroup',
  PARAGRAPH: 'p',
  PARTNERSHIP_CAROUSEL_TRACK: '.js-pc-track',
  PARTNERSHIP_CAROUSEL_WRAPPER: '.js-pc-wrapper',
  PARTNER_LOGO_SCROLL_TRACK: '.js-pls-track',
  PARTNER_LOGO_SCROLL_WRAPPER: '.js-pls-wrapper',
  POST_COUNT: '.post-count .count',
  POST_LISTING: '.post-listing',
  RADIO: '[type="radio"]',
  RESULTS_CONTAINER: '.results-container',
  SEARCH_INPUT: '.search-field__input',
  SELECTED: '.selected',
  SOLUTIONS_MODULE_SLIDER: 'solutions-module__slider',
  SPAN: 'span',
  STATISTIC_VALUE: '.statistic__value',
  STYLE: 'style',
  SUBMISSION_RESPONSE: '.submission-response',
  SUBMIT: '[type="submit"]',
  SWIPER_SLIDE: 'swiper-slide',
  SWIPER_WRAPPER: 'swiper-wrapper',
  TAB: '[role="tab"]',
  TABPANEL: '[role="tabpanel"]',
  TWITTER: '.share--tw',
  VIDEOS_AND_TEXT_EMBED: '[data-vt-embed]',
  VIDEOS_AND_TEXT_LIGHTBOX: '[data-vt-lightbox]',
  VIDEOS_AND_TEXT_LIGHTBOX_CLOSE: '[data-vt-lightbox-close]',
  VIDEOS_AND_TEXT_LIGHTBOX_EMBED: '[data-vt-lightbox-embed]',
  VIDEOS_AND_TEXT_LIGHTBOX_VIDEO: '[data-vt-lightbox-video]',
  VIDEOS_AND_TEXT_PREVIEW_IMAGE:
    'videos-and-text__repeater-block-video-preview-image',
  VIDEOS_AND_TEXT_THUMB: '[data-vt-thumb]',
  VIDEOS_AND_TEXT_TRIGGER: '[data-vt-trigger]',
  VIDEOS_AND_TEXT_VIDEO_SOURCE: 'source'
};

export default SELECTORS;
